import { render, staticRenderFns } from "./HorseMenuMobile.vue?vue&type=template&id=64736425&"
import script from "./HorseMenuMobile.vue?vue&type=script&lang=js&"
export * from "./HorseMenuMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports